import React from 'react';
import _, { get } from 'lodash';
import PropTypes from 'prop-types';
import moment from 'moment';
import { convertToUpperCase } from 'helper';

function Taxpayer({
  taxpayer,
  transactionInfo,
}) {
  const spanGap = 8;

  return (
    <>
      <div className='px-3' style={{ maxHeight: '700px', overflowY: 'scroll' }}>
        <table className="transaction-table table table-borderless table-sm">
          <tbody>
            <tr className='mt-3'>
              <td width="350">
                <span className="title" style={{ fontSize: '16px' }}>
                  APPLICANT INFORMATION
                </span>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                First Name
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(taxpayer, 'first_name') || '--'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Middle Name
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(taxpayer, 'middle_name') || '--'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Last Name
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(taxpayer, 'last_name') || '--'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Extension Name
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(taxpayer, 'extension_name') || '--'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Sex
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  {convertToUpperCase(_.get(taxpayer, 'gender'))}
                </b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Civil Status
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  {convertToUpperCase(_.get(taxpayer, 'civil_status'))}
                </b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Birth Date
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  {moment(_.get(taxpayer, 'birth_date')).format('MMMM DD, YYYY') || '--'}
                </b>
              </td>
            </tr> 
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Citizenship
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  {convertToUpperCase(_.get(taxpayer, 'citizenship_name'))}
                </b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Height
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  {convertToUpperCase(_.get(taxpayer, 'height'))}
                </b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Weight
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  {convertToUpperCase(_.get(taxpayer, 'weight'))}
                </b>
              </td>
            </tr>

            <tr className='mt-3'>
              <td width="350">
                <span className="title" style={{ fontSize: '16px' }}>
                  ADDRESS
                </span>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Region
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(taxpayer, 'region_name') || '--'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Province
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(taxpayer, 'province_name') || '--'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                City/Municipality
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(taxpayer, 'municipality_name') || '--'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Barangay
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  {_.get(taxpayer, 'barangay_name')}
                </b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Address Line 1
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(taxpayer, 'street') || '--'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Zip Code
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  {_.get(transactionInfo, 'included.taxPayer.attributes.zip_code') || '--'}
                </b>
              </td>
            </tr>

            <tr className='mt-3'>
              <td width="350">
                <span className="title" style={{ fontSize: '16px' }}>
                  PLACE OF BIRTH
                </span>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Region
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  {_.get(taxpayer, 'place_of_birth_region_name', '--')}
                </b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Province
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  {_.get(taxpayer, 'place_of_birth_province_name', '--')}
                </b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                City/Municipality
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  {_.get(taxpayer, 'place_of_birth_municipality_name', '--')}
                </b>
              </td>
            </tr>

            <tr className='mt-3'>
              <td width="350">
                <span className="title" style={{ fontSize: '16px' }}>
                  CONTACT INFORMATION
                </span>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Email
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  {_.get(taxpayer, 'email') || _.get(transactionInfo, 'attributes.email') || '--'}
                </b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Mobile Number
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  {_.get(taxpayer, 'mobile_number') || _.get(transactionInfo, 'attributes.mobile_number') || '--'}
                </b>
              </td>
            </tr>
            
            <tr className='mt-3'>
              <td width="350">
                <span className="title" style={{ fontSize: '16px' }}>
                  OTHER INFORMATION
                </span>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Currently earning income in the Philippines
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  {_.get(taxpayer, 'is_employed_individual') ? 'Yes' : 'No'}
                </b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Tax Identification Number
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  {_.get(taxpayer, 'tax_payer_account_number') || _.get(transactionInfo, 'included.taxPayer.attributes.tin_number') || '--'}
                </b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Profession/Occupation/Business
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  {_.get(taxpayer, 'profession_name', '--')}
                </b>
              </td>
            </tr>
            {get(taxpayer, 'profession_name') === 'OTHER' && (
              <tr>
                <td className="text-dark" colSpan={spanGap}>
                  Others
                </td>
                <td className="text-dark" width="1">
                  :
                </td>
                <td colSpan={4}>
                  <b>
                    {get(taxpayer, 'profession_other', '--')}
                  </b>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}

Taxpayer.defaultProps = {
  taxpayer: {},
  transactionInfo: {},
};

Taxpayer.propTypes = {
  taxpayer: PropTypes.instanceOf(Object),
  transactionInfo: PropTypes.instanceOf(Object),
};

export default Taxpayer;
